// Background asset
// Because we dont know wheater the element is present, we query the classList
const classListAssetBackground = document.getElementsByClassName('js-background')
const classLengthAssetBackground = classListAssetBackground.length

// If .js-background is present
if (classListAssetBackground !== 0) {
  // We want to stretch the asset in the background depending to the enclosed main-container
  const assetBackground = document.querySelectorAll('.js-background')
  assetBackground.forEach((element, index) => {
    if (element.firstChild.nextSibling) { // Do this if we have an enclosed container only
      // How it came to this:
      // console.log(element.firstChild, index + ' the firstChild') // Testing...
      // Container
      // console.log(element.firstChild.offsetHeight + 'px height of container')
      // console.log(element.firstChild.nextSibling.offsetHeight + 'px main-container height')
      // console.log(element.firstChild.tagName + ' = tagName') // Testing...
      // console.log(element.firstChild.className) // Testing...
      // Picture (mandatory markup)
      // <div class="main-wrapper ... js-background">
      //   {% picture shortcode %} <-- Our image background
      //   <div class="main-container"> <-- Positioned content
      //     {% include content %}
      //   </div>
      // </div>
      // console.log(element.firstChild.firstChild.srcset + ' first srcset of picture = AVIF') // Testing...
      // console.log(element.firstChild.lastChild.height + 'px = last element in scrset (img), for setting the height')
      // Video (mandatory markup)
      // <div class="main-wrapper ... js-background">
      //   <div class="a-video" data-attribution="... / ..."> <-- We need this wrapper for attribution, because data-* attribute is not visible on <video>
      //     <video class="js-lazyload-video" aria-hidden="true" playsinline autoplay muted loop> <-- Our video background
      //       <source data-src="..." type="video/webm">
      //       <source data-src="..." type="video/mp4">
      //     </video>
      //   </div>
      //   <div class="main-container"> <-- Positioned content
      //     {% include content %}
      //   </div>
      // </div>
      // console.log(element.lastChild.offsetHeight + ' = main container offsetHeight')
      // console.log(element.lastChild.className) // Testing...
      let containerPicture = element.firstChild.nextSibling.offsetHeight // Get the container height TODO: Evaluate better way to get the real height...
      let containerVideo = element.lastChild.offsetHeight // Get the container height TODO: Evaluate better way to get the real height...
      if (element.firstChild.tagName === 'PICTURE') { // We target the picture
        element.firstChild.lastChild.style.height = containerPicture + 75 + 'px' // Because I cant get the real height of the absolute positioned element, we add some pixel ;(
      }
      if (element.firstChild.firstChild.tagName === 'VIDEO') { // We target the video
        element.firstChild.firstChild.style.height = containerVideo + 75 + 'px' // Because I cant get the real height of the absolute positioned element, we add some pixel ;(
      }
    }
  })
}
